import './vanderbilt/style';
import FormStructure from './vanderbilt/form_structure';

export default FormStructure;